// Phase 6 — Track D T-D6. useOnline hook.
//
// Reads navigator.onLine and listens to the browser's online / offline
// events. Returns the current connectivity state as a boolean. SSR-safe
// (returns true on the server where navigator is undefined).

import * as React from 'react';

function getInitialOnline(): boolean {
  if (typeof navigator === 'undefined') return true;
  // navigator.onLine is universally available in browsers; default to true
  // when undefined so the offline banner is hidden in unusual environments.
  return navigator.onLine !== false;
}

export function useOnline(): boolean {
  const [online, setOnline] = React.useState<boolean>(getInitialOnline);

  React.useEffect(() => {
    const handleOnline = (): void => setOnline(true);
    const handleOffline = (): void => setOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    // Re-sync once on mount in case the snapshot at first render was stale.
    setOnline(getInitialOnline());
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return online;
}
